import { useState } from "react";
import { PuffLoader } from "react-spinners";
import { useTheme } from "@mui/material";
import { useTypedSelector } from "../../../store";
import "./actionSpinner.css";

const ActionSpinner = () => {
    const theme: any = useTheme();
    const [color] = useState(theme.palette.primary.main);
    const show = useTypedSelector((state) => state.spinnerReducer.showSpinner);

    return (
        <div className={show ? "showActionSpinner" : "hideActionSpinner"} key="spinner">
            <PuffLoader color={color} loading={show} size={150} />
        </div>
    );
};

export default ActionSpinner;
